export default "__VITE_ASSET__04648867__"